import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import CourtSearchService from '../../../service/courtSearch/courtSearch';
import {
  ApplyButton,
  Bottom,
  ButtonBox,
  ResetButton,
  Wrapper,
} from './OptionModal.styles';
import { FilterType } from '../FilterData';

const RegionList = [
  { name: '서울' },
  { name: '의정부' },
  { name: '인천' },
  { name: '수원' },
  { name: '춘천' },
  { name: '청주' },
  { name: '대전' },
  { name: '대구' },
  { name: '부산' },
  { name: '울산' },
  { name: '창원' },
  { name: '광주' },
  { name: '전주' },
  { name: '제주' },
];

interface Props {
  onClose: () => void;
  filters: FilterType;
  setFilters: (filters: FilterType) => void;
}

function CourtOption({ onClose, filters, setFilters }: Props) {
  const [sido, setSido] = useState('');
  const [selectCourt, setSelectCourt] = useState('');

  const [courtList, setCourtList] = useState<{ court: string }[]>([]);

  const getCourtList = async (sido: string) => {
    try {
      const res = await CourtSearchService.courtList(sido, '', '', '');
      if (res.data) {
        const mapped = res.data.map(({ court }: { court: string }) => {
          const [prefix, ...rest] = court.split(' ');
          return {
            court: `${prefix}지방법원 ${rest.join(' ')}`.trim(),
          };
        });
        return mapped;
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  useEffect(() => {
    if (sido !== null) {
      getCourtList(sido).then((res) => setCourtList(res));
    }
  }, [sido]);

  const handleReset = () => {
    setSido('');
    setSelectCourt('');
    setCourtList([]);
  };

  const handleSubmit = () => {
    setFilters({
      ...filters,
      court: selectCourt,
    });
    onClose();
  };

  return (
    <Wrapper>
      <Box>
        법원으로 검색
        <InputWrapper>
          {sido === '' ? (
            <RegionText>지역 선택</RegionText>
          ) : (
            <SelectedRegionText style={{ width: '70px' }}>
              {sido}
            </SelectedRegionText>
          )}
          <img
            src="/assets/images/arrow/arrow_right.svg"
            alt=""
            style={{ width: '24px', height: '24px' }}
          />
          {selectCourt === '' ? (
            <RegionText>법원 선택</RegionText>
          ) : (
            <SelectedRegionText style={{ width: '200px' }}>
              {selectCourt}
            </SelectedRegionText>
          )}
        </InputWrapper>
      </Box>
      <RegionSelector>
        <SidoColumn>
          {RegionList.map(({ name }) => (
            <SidoItem
              key={name}
              active={name === sido}
              onClick={() => {
                setSido(name);
              }}
            >
              {name}
            </SidoItem>
          ))}
        </SidoColumn>
        <Column>
          {courtList.map(({ court }) => (
            <Item
              key={court}
              active={court === selectCourt}
              onClick={() => {
                setSelectCourt(court);
              }}
            >
              {court}
            </Item>
          ))}
        </Column>
      </RegionSelector>
      <Bottom>
        <ButtonBox>
          <ResetButton onClick={handleReset}>
            <img
              src="/assets/images/icon/reset.svg"
              alt=""
              width={24}
              height={24}
            />
            <span>초기화</span>
          </ResetButton>
          <ApplyButton onClick={handleSubmit}>적용</ApplyButton>
        </ButtonBox>
      </Bottom>
    </Wrapper>
  );
}

export default CourtOption;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #e1e2e4;
  padding: 24px 16px;

  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #70737c0d;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const RegionText = styled.span`
  font-size: 16px;
  color: #37383c9c;
  flex: 1;
  white-space: nowrap;
  text-align: center;
`;

const SelectedRegionText = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;
`;

const RegionSelector = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 1px;
  height: 240px;
`;

const Column = styled.div`
  background-color: #fff;
  flex: 1;
  overflow-y: auto;
  border-right: 1px solid #e1e2e4;
`;

const SidoColumn = styled.div`
  width: 80px;
  background-color: #f5f5f5;
  overflow-y: auto;
  border-right: 1px solid #e1e2e4;
`;

const Item = styled.div<{ active: boolean }>`
  padding: 12px;
  cursor: pointer;
  color: ${({ active }) => (active ? '#008AFF' : '#222')};
  background-color: ${({ active }) => (active ? '#EAF2FE' : '#fff')};
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: center;
`;

const SidoItem = styled(Item)`
  color: ${({ active }) => (active ? '#222222' : '#37383C9C')};
  background-color: ${({ active }) => (active ? '#FFFFFF' : '#F5F5F5')};
`;
